import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';

// A screen-provided "back to X" button in the app header (e.g. a transfer
// offering the report that lists its type). The owning screen sets it when it
// knows where "back" is and clears it on destroy; `scope` is a safety net —
// once the URL leaves that prefix the link is dropped even if the owner never
// cleared it.
export interface HeaderBackLink {
  label: string;
  action: () => void;
  scope?: string;
}

@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  private backLink: HeaderBackLink = null;
  private backLinkChanged = new Subject<HeaderBackLink>();
  private locationsMenuRequested = new Subject<void>();

  constructor(router: Router) {
    router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      if (this.backLink && this.backLink.scope && !event.urlAfterRedirects.startsWith(this.backLink.scope)) {
        this.clearBackLink();
      }
    });
  }

  setBackLink(link: HeaderBackLink) {
    this.backLink = link;
    this.backLinkChanged.next(this.backLink);
  }

  clearBackLink() {
    if (this.backLink) {
      this.backLink = null;
      this.backLinkChanged.next(null);
    }
  }

  getBackLink(): HeaderBackLink {
    return this.backLink;
  }

  backLinkObservable(): Observable<HeaderBackLink> {
    return this.backLinkChanged.asObservable();
  }

  // A screen that needs a store selected (e.g. Price Check at "All Locations")
  // asks the header to open its location picker instead of leaving the user
  // to find it.
  requestLocationsMenu() {
    this.locationsMenuRequested.next();
  }

  locationsMenuRequestedObservable(): Observable<void> {
    return this.locationsMenuRequested.asObservable();
  }
}
